export default __webpack_public_path__ + "static/media/clickstreams_view_video_analytics.86c34f73.gif";